module.exports = __webpack_public_path__ + "img/product-3.e9e9d374.png";